var map = {
	"./app/layouts/empty-layout.vue": "./src/app/layouts/empty-layout.vue",
	"./app/layouts/header-layout.vue": "./src/app/layouts/header-layout.vue",
	"./app/layouts/sidebar-layout.vue": "./src/app/layouts/sidebar-layout.vue",
	"./app/layouts/simple-header.vue": "./src/app/layouts/simple-header.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive .+\\/layouts\\/.+\\.vue$";